import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'uploadedDuplicateProspects',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Uploaded Duplicate Prospects',
  },
}

const keys = {
  statKey: 'uploaded_dupe_prospects',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const uploadedDuplicateProspects = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { uploadedDuplicateProspects }
